import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    // Selected parameters
    selectedMeterIds: [],
    dateFrom: null,
    dateTo: null,
    resolution: 'hour',
    dateRange: 'day',

    // UI state
    isExporting: false,
    exportError: null,
    lastExportSuccess: false
}

const reportsSlice = createSlice({
    name: 'reports',
    initialState,
    reducers: {
        setSelectedMeterIds: (state, action) => {
            state.selectedMeterIds = action.payload
        },
        addSelectedMeterId: (state, action) => {
            if (!state.selectedMeterIds.includes(action.payload)) {
                state.selectedMeterIds.push(action.payload)
            }
        },
        removeSelectedMeterId: (state, action) => {
            state.selectedMeterIds = state.selectedMeterIds.filter((id) => id !== action.payload)
        },
        setDateRange: (state, action) => {
            state.dateRange = action.payload.range
            state.dateFrom = action.payload.dateFrom
            state.dateTo = action.payload.dateTo
        },
        setCustomDateRange: (state, action) => {
            state.dateFrom = action.payload.dateFrom
            state.dateTo = action.payload.dateTo
            state.dateRange = 'custom'
        },
        setResolution: (state, action) => {
            state.resolution = action.payload
        },
        setExporting: (state, action) => {
            state.isExporting = action.payload
            if (action.payload) {
                state.exportError = null
                state.lastExportSuccess = false
            }
        },
        setExportError: (state, action) => {
            state.exportError = action.payload
            state.isExporting = false
            state.lastExportSuccess = false
        },
        setExportSuccess: (state) => {
            state.isExporting = false
            state.exportError = null
            state.lastExportSuccess = true
        },
        resetReportState: (state) => {
            Object.assign(state, initialState)
        }
    }
})

export const {
    setSelectedMeterIds,
    addSelectedMeterId,
    removeSelectedMeterId,
    setDateRange,
    setCustomDateRange,
    setResolution,
    setExporting,
    setExportError,
    setExportSuccess,
    resetReportState
} = reportsSlice.actions

export default reportsSlice.reducer
